import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import KitSelectStyle from './AiKitSelection.module.css'
import renderImage from '../../source/importImg'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { setLanguageSelect, setSelectionBackRoute } from '../../redux/actions'
import { connect } from 'react-redux'
import { languageMenu } from '../../utils/langaugeSupport'
import KitSelectionHeader from '../ReusableComponents/Header/KitSelectionHeader'
import {
    getCatalogItems,
    isDeviceEnabled,
    getDeviceDisplayName,
    getAccessoryHeroImage,
    getDeviceKits,
    getDeviceCardSrc,
    getCardHeroImage,
} from '../../hooks/useBrandConfig'

const COMING_SOON_TEXT = 'Coming soon!'
const DISCONTINUED_TEXT = 'Discontinued!'


// Remembers which AI kit's Accessories grid was open, so navigating to
// /deviceSelection and back (a full unmount/remount of this component)
// restores the Accessories device list instead of dropping back to the
// Standalone/Accessories/Mobile AI hub.
const ACCESSORIES_VIEW_KEY = 'aiKitSelectionAccessoriesFor'

const AiKitSelection = (props) => {
    const aiDevice =
        props.device.kitSelection.selectedKit?.aiKitSelected ?? 'pcAiTool'

    const [supportedDevice, setSupportedDevice] = useState([])
    const [filteredResults, setFilteredResults] = useState({})
    const [aiDeviceObj, setAiDeviceObj] = useState({})
    const [showLanguagePopup, setShowLanguagePopup] = useState(false)
    const [languageValue, setLanguageValue] = useState(props.device.language)
    const [showAccessories, setShowAccessories] = useState(
        () => sessionStorage.getItem(ACCESSORIES_VIEW_KEY) === aiDevice
    )

    const [modelData, setModelData] = useState({
        isShow: false,
        text: '',
        type: '',
    })

    const history = useHistory()

    // AI 1 v1/v2 route through a Standalone/Accessories/Mobile AI hub before
    // the device grid; every other AI kit (Computer AI, Wifi Camera) skips it.
    const isAiOneKit = aiDevice === 'pcAiTool' || aiDevice === 'Ai0'

    // Only reset the hub view when the user actually switches to a different
    // AI kit — not on every mount, or a /deviceSelection round trip would
    // always land back on the hub instead of restoring the Accessories grid.
    const prevAiDeviceRef = useRef(aiDevice)
    useEffect(() => {
        if (prevAiDeviceRef.current !== aiDevice) {
            prevAiDeviceRef.current = aiDevice
            setShowAccessories(false)
            sessionStorage.removeItem(ACCESSORIES_VIEW_KEY)
        }
    }, [aiDevice])

    useEffect(() => {
        if (!aiDevice) {
            setSupportedDevice([])
            setAiDeviceObj({})
            return
        }

        const items = getCatalogItems()
        const aiItem = items.find(
            (it) =>
                (it.type === 'accessory' || it.type === 'web_ai') &&
                it.accessory_key === aiDevice
        )
        setAiDeviceObj(
            aiItem
                ? {
                    device: aiItem.accessory_key,
                    name: aiItem.display_name,
                    src: aiItem.src,
                }
                : {}
        )

        const supported = []
        ;((aiItem && aiItem.supported_devices) || [])
            .filter((key) => isDeviceEnabled(key))
            .forEach((key) => {
                const variants = getDeviceKits(key).filter(
                    (k) => k.peecee_variant
                )
                if (variants.length) {
                    variants.forEach((v) => {
                        supported.push({
                            device: key,
                            slug: v.slug,
                            name: v.display_name,
                            src: v.src || getDeviceCardSrc(key),
                            peeCeeVariant: v.peecee_variant,
                            discontinued: v.discontinued === true,
                        })
                    })
                    return
                }
                supported.push({
                    device: key,
                    name: getDeviceDisplayName(key),
                    src: getDeviceCardSrc(key),
                })
            })

        setSupportedDevice(
            supported.sort(
                (a, b) => (a.discontinued === true) - (b.discontinued === true)
            )
        )
    }, [aiDevice])

    const handleAutoConnection = () => {
        history.push('/deviceSelection')
        sessionStorage.setItem('webAiMode', 'true')
    }
    // const handleDefaultConnection = () => {}
    const handleDeviceConnection = (item) => {
        if (item.nav) window.open(item.nav, '_blank')
        else {
            props.setSelectedKit({
                ...item,
                aiKitSelected:
                    props.device.kitSelection.selectedKit?.aiKitSelected,
            })
            sessionStorage.setItem('allowedDevice', item.device)
            if (item.peeCeeVariant) {
                sessionStorage.setItem(
                    'allowedPeeCeeVariant',
                    item.peeCeeVariant
                )
            }
            props.setSelectionBackRoute('/aiKitSelection')
            history.push('/deviceSelection')
        }
    }

    const languageActionHandel = () => {
        props.setLanguageSelect({ language: languageValue })
        setShowLanguagePopup(false)
    }

    const gobackUrl = () => {
        if (isAiOneKit && showAccessories) {
            setShowAccessories(false)
            sessionStorage.removeItem(ACCESSORIES_VIEW_KEY)
            return
        }
        sessionStorage.setItem('slideDirection', true)
        history.push('/kitSelection')
    }

    return (
        <>
            <DialogModal
                show={showLanguagePopup}
                text={
                    <div>
                        <p>Select Your Prefer language</p>
                        <div>
                            <select
                                className={KitSelectStyle.language_select}
                                value={languageValue}
                                onChange={(e) =>
                                    setLanguageValue(e.target.value)
                                }
                            >
                                {languageMenu.map((ele) => {
                                    return <option value={ele}>{ele}</option>
                                })}
                            </select>
                        </div>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setShowLanguagePopup(false)}
                optionsToSelect={[
                    {
                        text: 'CONTINUE',
                        do: () => {
                            languageActionHandel()
                        },
                    },
                ]}
            />
            <KitSelectionHeader
                setShowLanguagePopup={setShowLanguagePopup}
                setFilteredResults={setFilteredResults}
                filteredResults={filteredResults}
                supportedDevice={supportedDevice}
            />

            <div className={KitSelectStyle.container}>
                <div className={KitSelectStyle.Connect_Body}>
                    <div
                        className={KitSelectStyle.sidebar}
                        style={{ padding: '1.25rem 0' }}
                    >
                        <div className={KitSelectStyle.sidebarCardParent}>
                            <div className={KitSelectStyle.sidebarCard}>
                                <div className={KitSelectStyle.cardImg}>
                                    <img
                                        src={
                                            getAccessoryHeroImage(
                                                aiDeviceObj.device
                                            ) ||
                                            renderImage(aiDeviceObj.src)
                                        }
                                        alt={aiDeviceObj.src}
                                    />
                                </div>
                                <p className={KitSelectStyle.cardName}>
                                    {aiDeviceObj.name}
                                </p>
                            </div>
                        </div>
                        {/* <button
                            className={KitSelectStyle.sidebarButton}
                            // disabled={true}
                        >
                            SOLO USE
                        </button> */}
                    </div>
                    <div className={KitSelectStyle.content}>
                        <p className={KitSelectStyle.contentPara}>
                            Select device to work with it
                        </p>
                        <div>
                            {filteredResults &&
                                Object.keys(filteredResults).length > 0 ? (
                                <div className={KitSelectStyle.tabContent}>
                                    <div
                                        onClick={() =>
                                            handleDeviceConnection(
                                                filteredResults
                                            )
                                        }
                                        className={KitSelectStyle.card}
                                    >
                                        <div className={KitSelectStyle.cardImg}>
                                            <img
                                                src={renderImage(
                                                    filteredResults.src
                                                )}
                                                alt={filteredResults.src}
                                            />
                                        </div>
                                        <p className={KitSelectStyle.cardName}>
                                            {filteredResults.name}
                                        </p>
                                    </div>
                                </div>
                            ) : isAiOneKit && !showAccessories ? (
                                <div className={KitSelectStyle.tabContent}>
                                    <div
                                        className={KitSelectStyle.card}
                                        style={{ cursor: 'not-allowed' }}
                                    >
                                        <div
                                            className={KitSelectStyle.cardImg}
                                            style={{ position: 'relative' }}
                                        >
                                            <img
                                                src={renderImage(
                                                    'aiHubStandalone'
                                                )}
                                                alt="Standalone"
                                            />
                                            <div
                                                className={
                                                    KitSelectStyle.comingSoonOverlay
                                                }
                                            >
                                                <div
                                                    className={
                                                        KitSelectStyle.comingSoonBanner
                                                    }
                                                >
                                                    {COMING_SOON_TEXT}
                                                </div>
                                            </div>
                                        </div>
                                        <p className={KitSelectStyle.cardName}>
                                            Standalone
                                        </p>
                                    </div>
                                    <div
                                        onClick={() => {
                                            setShowAccessories(true)
                                            sessionStorage.setItem(
                                                ACCESSORIES_VIEW_KEY,
                                                aiDevice
                                            )
                                        }}
                                        className={KitSelectStyle.card}
                                    >
                                        <div className={KitSelectStyle.cardImg}>
                                            <img
                                                src={renderImage(
                                                    'aiHubAccessories'
                                                )}
                                                alt="Accessories"
                                            />
                                        </div>
                                        <p className={KitSelectStyle.cardName}>
                                            Accessories
                                        </p>
                                    </div>
                                    <div
                                        className={KitSelectStyle.card}
                                        style={{ cursor: 'not-allowed' }}
                                    >
                                        <div
                                            className={KitSelectStyle.cardImg}
                                            style={{ position: 'relative' }}
                                        >
                                            <img
                                                src={renderImage('webAiKit')}
                                                alt="Mobile AI"
                                            />
                                            <div
                                                className={
                                                    KitSelectStyle.comingSoonOverlay
                                                }
                                            >
                                                <div
                                                    className={
                                                        KitSelectStyle.comingSoonBanner
                                                    }
                                                >
                                                    {COMING_SOON_TEXT}
                                                </div>
                                            </div>
                                        </div>
                                        <p className={KitSelectStyle.cardName}>
                                            Mobile AI
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div className={KitSelectStyle.tabContent}>
                                    {supportedDevice.map((ele, ind) => (
                                        <div
                                            key={ind}
                                            onClick={() =>
                                                handleDeviceConnection(ele)
                                            }
                                            className={KitSelectStyle.card}
                                        >
                                            <div
                                                className={
                                                    KitSelectStyle.cardImg
                                                }
                                                style={{ position: 'relative' }}
                                            >
                                                <img
                                                    src={
                                                        getCardHeroImage({
                                                            ...ele,
                                                            type: 'device',
                                                        }) ||
                                                        renderImage(ele.src)
                                                    }
                                                    alt={ele.src}
                                                    style={
                                                        ele.discontinued
                                                            ? {
                                                                filter: 'grayscale(100%)',
                                                                opacity: 0.7,
                                                            }
                                                            : undefined
                                                    }
                                                />
                                                {ele.discontinued && (
                                                    <div
                                                        className={
                                                            KitSelectStyle.discontinuedOverlay
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                KitSelectStyle.discontinuedBanner
                                                            }
                                                        >
                                                            {DISCONTINUED_TEXT}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <p
                                                className={
                                                    KitSelectStyle.cardName
                                                }
                                            >
                                                {ele.name}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* <div className={KitSelectStyle.Connect_Footer}>
                    <div>
                        <img
                            style={{ width: '90px', cursor: 'pointer' }}
                            src={renderImage('auto')}
                            alt="arrowRight"
                            onClick={handleAutoConnection}
                        />
                    </div>
                </div> */}

                <img
                    onClick={() => gobackUrl()}
                    // className="nextButton" //search for ".nextButton" in project directory to edit style
                    id="uploadLogicscrn"
                    src={renderImage('backBtn')}
                    style={{
                        position: 'absolute',
                        visibility: 'visible',
                        // top: '91%',
                        bottom: '4%',
                        left: '2%',
                        width: '60px',
                        // height: '60px',
                        cursor: 'pointer',
                        opacity: '1',
                    }}
                ></img>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        setLanguageSelect: (data) => {
            dispatch(setLanguageSelect(data))
        },
        setSocket: (data) => {
            dispatch({ type: 'SOCKET', payload: data })
        },
        setSelectedKit: (data) => {
            dispatch({ type: 'SET_SELECTED_KIT', payload: data })
        },
        setActiveTab: (data) => {
            dispatch({ type: 'SET_ACTIVE_TAB', payload: data })
        },
        setSelectionBackRoute: (data) => {
            dispatch(setSelectionBackRoute(data))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AiKitSelection)
